// Turns raw AcroForm field names (camelCase / PascalCase / digit-joined) into
// readable labels, e.g. "MotherMaidenName" -> "Mother Maiden Name",
// "Child1BirthDate" -> "Child 1 Birth Date". Idempotent for already-spaced labels.
// Word-level abbreviation expansions for NC court field labels.
const ABBREV = {
  pltf: "Plaintiff", plft: "Plaintiff", plntf: "Plaintiff", pl: "Plaintiff",
  deft: "Defendant", def: "Defendant", dft: "Defendant",
  petnr: "Petitioner", ptnr: "Petitioner", pet: "Petitioner",
  respdt: "Respondent", resp: "Respondent", rspdt: "Respondent",
  atty: "Attorney", attys: "Attorneys",
  juv: "Juvenile", cnty: "County", cty: "County",
  addr: "Address", amt: "Amount", nam: "Name",
};

// Exact full-label overrides (keyed by the lowercased humanized result).
const LABEL_OVERRIDES = {
  "incompetent adult address zip": "Plaintiff Attorney Zip Code",
  "plaintiff attorney mail address": "Plaintiff Attorney Suite Number",
};

export function humanizeLabel(s) {
  if (!s || typeof s !== "string") return s || "";
  let out = s
    .replace(/[_]+/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Za-z])(\d)/g, "$1 $2")
    .replace(/(\d)([A-Za-z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim();
  // Expand known abbreviations word-by-word (case-insensitive).
  out = out
    .split(" ")
    .map((w) => ABBREV[w.toLowerCase()] || w)
    .join(" ");
  // "Name Plaintiff" reads better as "Plaintiff Name" (from raw "NamPltf").
  out = out.replace(/\bName (Plaintiff|Defendant|Petitioner|Respondent)\b/gi, "$1 Name");
  // Apply any exact full-label override.
  return LABEL_OVERRIDES[out.toLowerCase()] || out;
}
